import { usePage } from "@inertiajs/react"
import type { PageProps } from "@/types/inertia"
import { BrandMotif } from "@/components/ui/brand-motif"

interface Props {
  testimonial: { quote: string; attribution: string } | null
}

export default function HomeTestimonial({ testimonial }: Props) {
  const { translations, features } = usePage<PageProps>().props
  const t = translations.sanctuary_pages.home

  // The i18n fallback quote below would resurrect a testimonial with the
  // feature off, so the whole section goes, not just the DB quote.
  if (!features.testimonials_display) return null

  const quote = testimonial?.quote ?? t.testimonial_quote
  const attribution = testimonial?.attribution ?? t.testimonial_attribution

  return (
    <section className="relative overflow-hidden bg-stone py-20">
      <BrandMotif variant="speckle" tone="navy-light" opacity={0.8} seed={7} className="absolute -bottom-10 right-16" />
      <div className="relative mx-auto max-w-2xl px-6 text-center lg:px-8">
        <div className="rounded-2xl bg-white p-10 ring-1 ring-hairline">
          <svg
            className="mx-auto mb-6 h-8 w-8 text-sage"
            fill="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z" />
          </svg>
          <blockquote>
            <p className="text-lg leading-relaxed text-ink-display" style={{ fontStyle: "italic" }}>
              {quote}
            </p>
            <footer className="mt-6">
              <cite className="text-sm text-ink-muted not-italic">{attribution}</cite>
            </footer>
          </blockquote>
        </div>
      </div>
    </section>
  )
}
